import slide from "../module/slide/slideManager";
import tab from '../module/global/tab';
import productlist from '../module/global/productList';
import accordion from '../module/global/accordion';
import modal from '../module/global/modal';

export default class topManager {
    constructor(effect,scroll,param,hash) {

        this.effect = effect;

        this.slide = new slide();
        this.tab = new tab(effect);
        this.productlist = new productlist();
        this.accordion = new accordion();
        this.modal = new modal();

        this.status = {
            hash : hash
        }
        this.param = param;

        this.scroll = scroll;

    }
    init(scroll,mouse){

        this.effect.scale(document.querySelectorAll(".js__sp-scale"),"set");
        this.effect.svg(document.getElementById("p-kv-copy"),"set");
        this.effect.splitText(document.querySelectorAll(".js__sp-split"),"set");
        if(location.hash){
            this.$anchor = document.querySelector(location.hash);
        }

        TweenMax.set(document.getElementById("p-kv-copy-parts__inner"),{
            x : -100 + "%"
        })
        TweenMax.set(document.getElementById("p-kv-copy-parts__inner").querySelectorAll("svg"),{
            x : 100 + "%"
        })

        setTimeout(()=>{
            this.effect.svg(document.querySelectorAll(".js__sp-svg")[0],"show");
            this.effect.panel(document.querySelectorAll(".js__sp-image-mask"),"show");
            this.effect.scale(document.querySelectorAll(".js__sp-scale"),"show");

            setTimeout(()=>{
                this.effect.splitText(document.querySelectorAll("#p-kv-text >* >*"),"show");
                TweenMax.to([document.getElementById("p-kv-copy-parts__inner"),document.getElementById("p-kv-copy-parts__inner").querySelectorAll("svg")],0.4,{
                    x : 0 + "%"
                })

                // アンカーリンク遷移
                if(location.hash){
                    let rect = this.$anchor.getBoundingClientRect();
                    if(this.param.displayType !== 'sp'){ //pc
                        let _position = rect.top + window.pageYOffset - 150;
                        this.scroll.to(_position);
                    }else{ //sp
                        let _position = rect.top + window.pageYOffset - 100;
                        this.scroll.to(_position);
                    }
                }
            },1e3)
        },3e2)


        this.slide.init(); //js__tab-sp-trigger
        if(document.querySelectorAll(".js__tab-trigger")[0]) this.tab.init();
        this.productlist.init();
        if(document.querySelectorAll(".js__tab-sp-trigger")[0]) this.accordion.init(scroll);
        this.modal.init(scroll,mouse);


    }
    render(mouse,scrollInc){

    }
    resize(w,h,deviceSize){
        this.slide.resize();
        this.productlist.resize(deviceSize);
        if(document.querySelectorAll(".js__tab-trigger")[0]) this.tab.resize(deviceSize);
        if(document.querySelectorAll(".js__tab-sp-trigger")[0]) this.accordion.resize(deviceSize);

    }
}